"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostMessageBodyToJSON = exports.PostMessageBodyFromJSONTyped = exports.PostMessageBodyFromJSON = void 0;
function PostMessageBodyFromJSON(json) {
    return PostMessageBodyFromJSONTyped(json, false);
}
exports.PostMessageBodyFromJSON = PostMessageBodyFromJSON;
function PostMessageBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'message': json['message'],
    };
}
exports.PostMessageBodyFromJSONTyped = PostMessageBodyFromJSONTyped;
function PostMessageBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'message': value.message,
    };
}
exports.PostMessageBodyToJSON = PostMessageBodyToJSON;
